import { Container, Grid, Paper, styled } from '@mui/material';
import { bounceUp } from 'assets/styles/animations';

export const StyledBox = styled('div')`
  animation: ${bounceUp} 1s ease-in-out forwards;
  padding: 2rem;

  & + & {
    padding-top: 0;
  }
`;

export const StyledContainer = styled(Container)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
`;

export const StyledPaper = styled(Paper)`
  border-radius: ${({ theme }) => theme.radius?.lg};

  ${({ theme }) => theme.breakpoints.down('md')} {
    box-shadow: none;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-top: 60px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding-top: 40px;
  }
`;

export const StyledGridContainer = styled(Grid)`
  margin-top: 0;
  padding-bottom: 60px;
`;

export const StyledGrid = styled(Grid)`
  width: 100%;
`;

export const EmptyPerkzWrapper = styled('div')`
  align-items: center;
  border-radius: ${({ theme }) => theme.radius?.md};
  border: 3px dashed ${({ theme }) => theme.palette.primary.main};
  display: flex;
  flex-direction: column;
  height: 222px;
  justify-content: center;
  padding: 1rem;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('md')} {
    height: 267px;
  }

  .MuiButton-root {
    margin-top: 1rem;
  }
`;
